module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-buttonList"
  }, [_c('div', {
    staticClass: "page-buttonList-item"
  }, [_c('mt-button-list', {
    attrs: {
      "label": "单选按钮组",
      "options": _vm.options,
      "display": _vm.value_display
    },
    on: {
      "update:display": function($event) {
        _vm.value_display = $event
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }), _vm._v(" "), _c('p', [_vm._v("value: " + _vm._s(_vm.value))]), _vm._v(" "), _c('p', [_vm._v("display: " + _vm._s(_vm.value_display))])], 1), _vm._v(" "), _c('mt-layout-spacing'), _vm._v(" "), _c('div', {
    staticClass: "page-buttonList-item"
  }, [_c('mt-button-list', {
    attrs: {
      "label": "多选按钮组",
      "multiple": true,
      "options": _vm.options,
      "display": _vm.multiValue_display
    },
    on: {
      "update:display": function($event) {
        _vm.multiValue_display = $event
      }
    },
    model: {
      value: (_vm.multiValue),
      callback: function($$v) {
        _vm.multiValue = $$v
      },
      expression: "multiValue"
    }
  }), _vm._v(" "), _c('p', [_vm._v("value: " + _vm._s(_vm.multiValue))]), _vm._v(" "), _c('p', [_vm._v("display: " + _vm._s(_vm.multiValue_display))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34955096","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/button-list.vue
// module id = 105
// module chunks = 0